import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {  Drawer, Radio, Space } from 'antd';
import FilterSelect from "components/Form/filterSelect"
import {  useSelector } from 'react-redux';
import { uniformTypeOptions, uniformGenderOptions, activeStatusOptions } from 'utils/constants';
import FilterDate from "components/Form/dateFilterInput"
import { Button } from 'components/Button';

const ResignationFilterDrawer = ({
   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,
    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDateChange

}) => {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState('right');  
   const {
    userData, userDataLoading,
    department, departmentLoading 
} = useSelector((state) => state.common);


const [userDataOption, setUserDataOption] = useState([]);
const [departmentOption, setDepartmentOption] = useState([]);



useEffect(()=>{
   
    let _userData = userData?.map(item=> {
        return{
            label: item.first_name+" "+item.last_name,
            value: item.id
        }
    })

    let _department = department?.map(item=> {
      return{
          label: item.name,
          value: item.id
      }
  })

    setUserDataOption(_userData)  
    setDepartmentOption(_department)  

},[userData, department])




   const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);


  const setInputValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        return selectedValue?.value
    }
    return ""

  }, [filters]);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const onChange = (e) => {
    setPlacement(e.target.value);
  };
  return (
    <>
      <Drawer
        title="Basic Drawer"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}
      >
        <div className="col mb-3 d-flex justify-content-between">
          <h3 className="page-title">Filters</h3>
          <i onClick={handleFilterDrawer}  className='la la-close cursor-pointer ' />
        </div>

    

        <div className='col-12 mb-3' >
          {/* Deptment Filter */}
          <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "department")}} optionLabel={"label"} optionValue={'value'} options={departmentOption} value={setFilterValue("department")} placeholder={"Select Department"}/>
        </div>

        <div className='col-12 mb-3' >
         {/* Gender Filter */}
         <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "gender")}} optionLabel={"label"} optionValue={'value'} options={uniformGenderOptions} value={setFilterValue("gender")} placeholder={"Select Gender"}/>
        </div>

       

        <div className='col-12 mb-3' >
             {/* Status Filter */}
         <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "status")}} optionLabel={"label"} optionValue={'value'} options={activeStatusOptions} value={setFilterValue("status")} placeholder={"Select Status"}/>
        </div>

    

        <div className="col-12">
          <Button label="Search" loading={filterLoading} disabled={filterLoading} onClick={handleApplyFilter}   className="btn btn-primary  w-100"/>    
     
       </div>

      </Drawer>
    </>
  );
};
export default ResignationFilterDrawer;